import * as React from 'react';

import type {GetAccountBilling_accountBilling_currentPlan_crm_coupon as Coupon} from 'nutshell-graphql-types';

import {StackLegacy} from '../../layout/stack/stack-legacy';
import {PopoverInfo} from '../../popover-info/popover-info';
import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';

import styles from './coupon-pill.module.css';

type Props = {
    coupon: Coupon;
};

export function CouponPill(props: Props) {
    const appliedTime = props.coupon.appliedAt;
    const expiresTime = props.coupon.expiresAt;

    const moreInfo = (appliedTime || expiresTime) && (
        <div className={styles.info}>
            <StackLegacy spacing={8}>
                {appliedTime && (
                    <div className='flex flex-wrap'>
                        <span>’{props.coupon.name}’ applied on&nbsp;</span>
                        <FormattedTimestamp
                            format={FormattedTimestamp.formats.longMonthDay}
                            datetime={appliedTime}
                        />
                    </div>
                )}
                {expiresTime && (
                    <StackLegacy spacing={8}>
                        {props.coupon.displayInfo ? <span>{props.coupon.displayInfo}</span> : null}
                        <div className='flex flex-wrap italic'>
                            <span>Expires&nbsp;</span>
                            <FormattedTimestamp
                                format={FormattedTimestamp.formats.longMonthDayWithYear}
                                datetime={expiresTime}
                            />
                        </div>
                    </StackLegacy>
                )}
            </StackLegacy>
        </div>
    );

    return (
        <div className={styles.container}>
            {props.coupon.name}{' '}
            {moreInfo && <PopoverInfo size={16} info={moreInfo} variant='green' bodyColor='dark' />}
        </div>
    );
}
